function BlankTemplate({ title, message, styling, content }) {
  // ✅ STAGE 1 FIX: Use VITE_API_URL from env (works in dev + production)
  const API_URL = import.meta.env.VITE_API_URL || window.location.origin;
  
  // Font defaults
  const headerFont = styling?.headerFont || 'Montserrat';
  const bodyFont = styling?.bodyFont || 'Raleway';
  
  // Color defaults
  const backgroundColor = styling?.backgroundColor || '#ffffff';
  const textColor = styling?.textColor || '#000000';
  
  // ✅ Logo - TOP LEFT - DISABLED BY DEFAULT
  const showLogo = styling?.showLogo === false; // Default to false
  const logoUrl = `${API_URL}/signagelogo.png`;
  
  // Content
  const headerTitle = title || 'Header Title';
  const bodyText = message || `Welcome to <strong>Ella's Place!</strong><br><br>

<strong>Today's Classes:</strong><br>
<ul>
<li>Zumba - 8.00am</li>
<li>Yoga - 1.00pm</li>
<li>Dance class - 7.00pm</li>
</ul>

<em>Lets get you in shape</em>`;
  
  // ✅ STAGE 4: QR Code settings
  const showQR = content?.ctaEnabled === true;
  const whatsappNumber = '2349055444495';
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=https://wa.me/${whatsappNumber}`;

  // ✅ Check if media is video
  const isVideo = styling?.announcementImage && (
    styling.announcementImage.endsWith('.mp4') ||
    styling.announcementImage.endsWith('.webm') ||
    styling.announcementImage.endsWith('.ogg')
  );

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: backgroundColor,
        color: textColor,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Ella's Logo - TOP LEFT */}
      {showLogo && (
        <img
          src={logoUrl}
          alt="Ella's Place"
          style={{
            position: 'absolute',
            top: '1rem',
            left: '2rem',
            width: '80px',
            height: 'auto',
            opacity: 0.4,
            zIndex: 10,
          }}
          onError={(e) => {
            console.error('Logo failed to load from:', logoUrl);
            e.target.style.display = 'none';
          }}
        />
      )}

      {/* Left Section - 60% width - Content */}
      <div
        style={{
          width: '60%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '2.5rem 3rem',
        }}
      >
        {/* Header Title */}
        <div
          style={{
            fontFamily: `${headerFont}, Montserrat, system-ui, sans-serif`,
            fontSize: styling?.fontSize === 'small' ? '2.5rem' : 
                     styling?.fontSize === 'large' ? '4rem' : '3.2rem',
            fontWeight: '900',
            lineHeight: '1.1',
            marginBottom: '1rem',
          }}
        >
          {headerTitle}
        </div>

        {/* Body Text - ✅ NOW SUPPORTS HTML FORMATTING */}
        <div
          style={{
            fontFamily: `${bodyFont}, Raleway, system-ui, sans-serif`,
            fontSize: '1.6rem',
            lineHeight: '1.5',
            fontWeight: '400',
            marginBottom: showQR ? '2rem' : '0',
          }}
          dangerouslySetInnerHTML={{ __html: bodyText }}
        />

        {/* ✅ STAGE 4: QR Code - Conditional */}
        {showQR && (
          <div
            style={{
              marginTop: '2rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '0.8rem',
            }}
          >
            <div
              style={{
                fontFamily: `${bodyFont}, Raleway, system-ui, sans-serif`,
                fontSize: '1rem',
                fontWeight: '600',
                color: textColor,
                opacity: 0.8,
              }}
            >
              Scan to Chat
            </div>
            <img
              src={qrCodeUrl}
              alt="WhatsApp QR Code"
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                padding: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              }}
            />
          </div>
        )}
      </div>

      {/* Right Section - 40% width - Image/Video */}
      <div
        style={{
          width: '40%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {styling?.announcementImage ? (
          isVideo ? (
            <video
              src={`${API_URL}${styling.announcementImage}`}
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <img
              src={`${API_URL}${styling.announcementImage}`}
              alt="Announcement"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          )
        ) : (
          // ✅ Subtle gradient instead of placeholder text
          <div
            style={{
              width: '100%',
              height: '100%',
              background: `linear-gradient(135deg, ${backgroundColor}00 0%, ${textColor}08 100%)`,
            }}
          />
        )}
      </div>

      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Raleway:wght@400;500;600;700;800;900&display=swap');
        `}
      </style>
    </div>
  );
}

export default BlankTemplate;